function SearchParentsFor(start, cls, top) {
  var result;

  var parent = start.parentNode;
  if (parent && parent.getAttribute) {
    var pcls = parent.getAttribute("class");
    if (pcls) {
      var pclsArray = pcls.split(" ");
      for (var i = 0; i < pclsArray.length; i++) {
        if (pclsArray[i] == cls) {
          result = parent;
          break;
        }
      }
    }

    if (!result && (!top || parent != top)) {
      result = SearchParentsFor(parent, cls, top);
    }
  }

  return result;
}

function HandleSuccess(e) {
  var type = e.currentTarget.dataset.type;
  if (type != "consultation") {
    window.lintrk("track", { conversion_id: 24030218 });
    fbq("track", "Lead", {});
  }
  window.location.href =
    window.location.origin +
    "/pages/thank-you?type=" +
    encodeURIComponent(type);
}

function showRequestCatalogueForm(element) {
  var catalogueForm = document.querySelector(".commercial-popup");

  if ((catalogueForm.style.display = "none")) {
    catalogueForm.style.display = "block";
  }
}

function handleFormNavigation(element) {
  var parent = document.querySelector(".commercial-popup-inner");
  var method = $(".action_button.active").data("method");
  var count = 0;

  var methodsContainer = document.querySelector(".panel_methods");
  if (method) {
    if (methodsContainer.classList.contains("hidden")) {
      methodsContainer.classList.remove("hidden");
    } else {
      methodsContainer.classList.add("hidden");
    }

    var forms = document.querySelectorAll(".bridgman_catalogue_panel");
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      var formName = form.dataset.name;
      form.classList.add("hidden");
      if (formName == method) {
        form.classList.remove("hidden");
      }
    }
  } else {
    if (count > 0) {
      $(
        '<p class="methodError" style="margin-top:10px;text-align:left;font-size: 18px;color:#c14848;font-weight: 500;">Select at least one method.</p>',
      ).insertAfter(".panel_methods .panel_heading");
      count++;
    }
  }
}

function setTelInputFilter(textbox, inputFilter) {
  // Convert HTML Collection to an array:
  var inputArray = Array.prototype.slice.call(textbox);
  var eventArray = [
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mouseup",
    "select",
    "contextmenu",
    "drop",
  ];

  for (var i = 0; i < eventArray.length; i++) {
    var event = eventArray[i];
    for (var j = 0; j < inputArray.length; j++) {
      var input = inputArray[j];
      input.addEventListener(event, function () {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        } else {
          this.value = "";
        }
      });
    }
  }
}

function onSearchBlur() {
  var mannualAddress = document.querySelector("#manual-address");
  mannualAddress.checked = false;
}

window.addEventListener("DOMContentLoaded", function (e) {
  $('a[ href="#catalogue" ]').on("click", function () {
    showRequestCatalogueForm(e.currentTarget);
  });

  setTelInputFilter(
    document.querySelectorAll(".number-input"),
    function (value) {
      return /^\d*\.?\d*$/.test(value); // Allow digits and '.' only, using a RegExp
    },
  );
});

$(document).ready(function () {
  var whereDidYouHeaderAboutUs = document.getElementById(
    "catalogue_Where_did_you_hear_about_us",
  );
  if (whereDidYouHeaderAboutUs) {
    whereDidYouHeaderAboutUs.addEventListener("change", function () {
      var input_other = document.getElementById(
        "catalogue_Where_did_you_hear_about_us_other",
      );
      if (this.value == "Other") {
        input_other.classList.remove("hide");
      } else {
        input_other.classList.add("hide");
      }
    });
  }

  $("#commercial-page-form-email").submit(function (e) {
    e.preventDefault();
    e.stopImmediatePropagation(); // This is to prevent the .submit firing twice

    var submitBtn = e.currentTarget.querySelector(".request-btn");
    submitBtn.classList.add("submitting");
    submitBtn.setAttribute("disabled", "disabled");

    hj("event", "commercial_catalogue_request");
    var pannel = SearchParentsFor(e.currentTarget, "bridgman_catalogue_panel");

    var selectedCatalogues = document.querySelectorAll(
      ".bridgman-commercial-catalogue-list-container .single_book .active",
    );

    function HandleCatalogues(catalogueName, catalogueType) {
      document.querySelector(".catalogue-error-text")?.classList.add("hidden");

      const form = e.currentTarget;

      const getValue = (selector, defaultValue = "") =>
        form.querySelector(selector)?.value ?? defaultValue;

      const getChecked = (selector, defaultValue = false) =>
        form.querySelector(selector)?.checked ?? defaultValue;

      const first_name = getValue("#catalogue_First_Name");
      const last_name = getValue("#catalogue_Last_Name");
      const email = getValue("#catalogue_email");
      const phone_number = getValue("#catalogue_Phone");
      const company_name = getValue("#commercial-popup_Company_Name");
      const Postcode = getValue("#post_code");
      const company_website = getValue("#company_website");
      const company_sector = getValue("#catalogue_sector");
      const accepts_marketing = getChecked("input[name='data-capture']");

      let Where_did_you_hear_about_us = getValue(
        '[name="catalogue_Where_did_you_hear_about_us"]',
      );

      if (Where_did_you_hear_about_us === "Other") {
        Where_did_you_hear_about_us = getValue(
          '[name="catalogue_Where_did_you_hear_about_us_other"]',
        );
      }

      const catalogue = {
        Response_Type: "Email",
        Catalogue_Type: catalogueType.toString(),
        Catalogue_Name: catalogueName,
        Postcode,
        $email: email,
        $first_name: first_name,
        $last_name: last_name,
        $phone_number: phone_number,
        $company_name: company_name,
        $company_website: company_website,
        $company_sector: company_sector,
        $source: Where_did_you_hear_about_us,
      };

      if (accepts_marketing) {
        catalogue.$accepts_marketing = true;
      }

      const properties = {
        $email: email,
        Catalogue_Type: catalogue.Catalogue_Type,
        Catalogue_Name: catalogue.Catalogue_Name,
        $source: catalogue.$source,
        Response_Type: "Email",
        ...(catalogue.$accepts_marketing && {
          $accepts_marketing: true,
        }),
      };

      let mergedProperties = properties;
      let mergedCatalogue = catalogue;

      const utmProperties = utmParams();

      if (utmProperties) {
        mergedProperties = { ...properties, ...utmProperties };
        mergedCatalogue = { ...catalogue, ...utmProperties };
      }

      const trackProperties = {
        event: "Request Catalogue",
        trackData: mergedCatalogue,
      };

      KlaviyoTrackV2(mergedProperties, trackProperties, function () {
        jQuery
          .post(
            "https://hooks.zapier.com/hooks/catch/9220888/2mlk13x/",
            mergedCatalogue,
          )
          .then(function () {
            HandleSuccess(e);
            submitBtn.classList.remove("submitting");
            submitBtn.setAttribute("disabled", "disabled");
          });
      });
    }
    if (selectedCatalogues && selectedCatalogues.length > 0) {
      var catalogueName = [];
      var catalogueType = [];
      if (selectedCatalogues.length > 1) {
        for (var i = 0; i < selectedCatalogues.length; i++) {
          catalogueName.push(
            selectedCatalogues[i].getAttribute("data-catalogue-name"),
          );
          if (
            catalogueType.includes(
              selectedCatalogues[i].getAttribute("data-catalogue-type"),
            ) == false
          ) {
            catalogueType.push(
              selectedCatalogues[i].getAttribute("data-catalogue-type"),
            );
          }
        }
        catalogueName = "MULTIPLE - " + catalogueName.toString();
      } else {
        catalogueName = selectedCatalogues[0].getAttribute(
          "data-catalogue-name",
        );
        catalogueType.push(
          selectedCatalogues[0].getAttribute("data-catalogue-type"),
        );
      }
      HandleCatalogues(catalogueName, catalogueType);
    } else {
      var parent = e.currentTarget.parentNode;
      parent.querySelector(".catalogue-error-text").classList.remove("hidden");
    }
  });

  $("#commercial-page-form").submit(function (e) {
    e.preventDefault();
    e.stopImmediatePropagation(); // This is to prevent the .submit firing twice

    var submitBtn = e.currentTarget.querySelector(".request-btn");
    submitBtn.classList.add("submitting");
    submitBtn.setAttribute("disabled", "disabled");

    hj("event", "commercial_catalogue_request");
    var selectedCatalogues = document.querySelectorAll(
      ".bridgman-commercial-catalogue-list-container .single_book .active",
    );

    function HandleCatalogues(catalogueName, catalogueType) {
      document.querySelector(".catalogue-error-text")?.classList.add("hidden");
      const form = e.currentTarget;

      const getValue = (selector, defaultValue = "") =>
        form.querySelector(selector)?.value ?? defaultValue;

      const getChecked = (selector, defaultValue = false) =>
        form.querySelector(selector)?.checked ?? defaultValue;

      const first_name = getValue("#catalogue_First_Name");
      const last_name = getValue("#catalogue_Last_Name");
      const email = getValue("#catalogue_email");
      const phone_number = getValue("#catalogue_Phone");
      const company_name = getValue("#commercial-popup_Company_Name");
      const Postcode = getValue("#post_code");
      const Address_Line_1 = getValue("#address_line_1");
      const Address_Line_2 = getValue("#address_line_2");
      const City = getValue("#city");
      const Country = getValue("#country");
      const company_website = getValue("#company_website");
      const company_sector = getValue("#catalogue_sector");
      const accepts_marketing = getChecked("input[name='data-capture']");
      let Where_did_you_hear_about_us = getValue(
        '[name="catalogue_Where_did_you_hear_about_us"]',
      );

      if (Where_did_you_hear_about_us === "Other") {
        Where_did_you_hear_about_us = getValue(
          '[name="catalogue_Where_did_you_hear_about_us_other"]',
        );
      }

      const catalogue = {
        Response_Type: "POST",
        Catalogue_Type: catalogueType.toString(),
        Catalogue_Name: catalogueName,
        Postcode,
        $email: email,
        $first_name: first_name,
        $last_name: last_name,
        $address1: Address_Line_1,
        $address2: Address_Line_2,
        $city: City,
        $country: Country,
        $phone_number: phone_number,
        $company_name: company_name,
        $company_website: company_website,
        $company_sector: company_sector,
        $source: Where_did_you_hear_about_us,
      };

      if (accepts_marketing) {
        catalogue.$accepts_marketing = true;
      }

      const properties = {
        $email: email,
        Catalogue_Type: catalogue.Catalogue_Type,
        Catalogue_Name: catalogue.Catalogue_Name,
        $source: catalogue.$source,
        Response_Type: "POST",
        ...(catalogue.$accepts_marketing && {
          $accepts_marketing: true,
        }),
      };

      let mergedProperties = properties;
      let mergedCatalogue = catalogue;

      const utmProperties = utmParams();

      if (utmProperties) {
        mergedProperties = { ...properties, ...utmProperties };
        mergedCatalogue = { ...catalogue, ...utmProperties };
      }

      const trackProperties = {
        event: "Request Catalogue",
        trackData: mergedCatalogue,
      };

      KlaviyoTrackV2(mergedProperties, trackProperties, function () {
        jQuery
          .post(
            "https://hooks.zapier.com/hooks/catch/9220888/2mlk13x/",
            mergedCatalogue,
          )
          .then(function () {
            HandleSuccess(e);
            submitBtn.classList.remove("submitting");
            submitBtn.setAttribute("disabled", "disabled");
          });
      });
    }
    if (selectedCatalogues && selectedCatalogues.length > 0) {
      var catalogueName = [];
      var catalogueType = [];
      if (selectedCatalogues.length > 1) {
        for (var i = 0; i < selectedCatalogues.length; i++) {
          catalogueName.push(
            selectedCatalogues[i].getAttribute("data-catalogue-name"),
          );
          if (
            catalogueType.includes(
              selectedCatalogues[i].getAttribute("data-catalogue-type"),
            ) == false
          ) {
            catalogueType.push(
              selectedCatalogues[i].getAttribute("data-catalogue-type"),
            );
          }
        }
        catalogueName = "MULTIPLE - " + catalogueName.toString();
      } else {
        catalogueName = selectedCatalogues[0].getAttribute(
          "data-catalogue-name",
        );
        catalogueType.push(
          selectedCatalogues[0].getAttribute("data-catalogue-type"),
        );
      }
      HandleCatalogues(catalogueName, catalogueType);
    } else {
      var parent = e.currentTarget.parentNode;
      parent.querySelector(".catalogue-error-text").classList.remove("hidden");
    }
  });

  $("#consultation-page-form").on("submit", function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const form = e.currentTarget;
    const submitBtn = form.querySelector(".request-btn");

    if (submitBtn) {
      submitBtn.classList.add("submitting");
      submitBtn.setAttribute("disabled", "disabled");
    }

    const getValue = (selector, fallback = "") => {
      const el = form.querySelector(selector);
      return el && "value" in el ? el.value : fallback;
    };

    const getChecked = (selector, fallback = false) => {
      const el = form.querySelector(selector);
      return el && "checked" in el ? el.checked : fallback;
    };

    // note: some of these fields are legacy
    const first_name = getValue("#consulatation_Firstname");
    const last_name = getValue("#consulatation_Lastname");
    const email = getValue("#catalogue_email");
    const phone_number = getValue("#catalogue_Phone");
    const company_name = getValue("#commercial-popup_Company_Name");
    const company_website = getValue("#company_website");
    const Postcode = getValue('[name="catalogue_Postcode"]');
    const company_sector = getValue("#catalogue_sector");
    const project_type = getValue("#catalogue_project_type");
    const installation_date = getValue("#catalogue_Installation_Date");
    const expected_budget = getValue("#catalogue_Expected_Budget");
    const consultation_type = getValue("#catalogue_Consultation_Type");
    const accepts_marketing = getChecked("input[name='data-capture']");
    const tell_us_more = getValue("#catalogue_Notes");

    let Where_did_you_hear_about_us = getValue(
      '[name="catalogue_Where_did_you_hear_about_us"]',
    );

    if (Where_did_you_hear_about_us === "Other") {
      Where_did_you_hear_about_us = getValue(
        '[name="catalogue_Where_did_you_hear_about_us_other"]',
      );
    }

    const consultationCustomer = {
      Catalogue_Type: "",
      $first_name: first_name,
      $last_name: last_name,
      $email: email,
      $phone_number: phone_number,
      $company_name: company_name,
      Postcode: Postcode,
      $company_website: company_website,
      $company_sector: company_sector,
      $tell_us_more: tell_us_more,
      $source: Where_did_you_hear_about_us,
      //$project_type: project_type,
      $installation_date: installation_date,
      $expected_budget: expected_budget,
      $consultation_type: consultation_type,
    };

    if (accepts_marketing) {
      consultationCustomer.$accepts_marketing = true;
    }

    const properties = consultationCustomer.$accepts_marketing
      ? {
          $email: email,
          Catalogue_Type: "",
          Catalogue_Name: "",
          $source: consultationCustomer.$source,
          Response_Type: "POST",
          $accepts_marketing: true,
        }
      : {
          $email: email,
          Catalogue_Type: "",
          Catalogue_Name: "",
          $source: consultationCustomer.$source,
          Response_Type: "POST",
        };

    let mergedProperties = properties;
    let mergedCustomer = consultationCustomer;

    const utmProperties = utmParams();
    if (utmProperties) {
      mergedProperties = { ...properties, ...utmProperties };
      mergedCustomer = { ...consultationCustomer, ...utmProperties };
    }

    const trackProperties = {
      event: "Request Consultation",
      trackData: mergedCustomer,
    };

    //const zapHook = "https://hooks.zapier.com/hooks/catch/9220888/on3arzi/";
    const zapHook = "https://hooks.zapier.com/hooks/catch/9220888/4oh94n9/";

    KlaviyoTrackV2(mergedProperties, trackProperties, function () {
      jQuery
        .post(zapHook, mergedCustomer)
        .then(function () {
          HandleSuccess(e);
        })
        .always(function () {
          if (submitBtn) {
            submitBtn.classList.remove("submitting");
            submitBtn.removeAttribute("disabled");
          }
        });
    });
  });
});
